import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import config from '../../../config';

import { getLayout } from '../../../bundles/layouts';
import { getSources } from '../../../bundles/sources';
import JsonEditor from '../../JsonEditor';

import {
  SWITCHGEAR_COUNTER_TABLE_TYPE,
  getAnalyticsTableOptionsSchema,
  normalizeAnalyticsTableSettings,
} from '../../panels/AnalyticsTablePanel';

const AnalyticsTableSettings = ({
  settings,
  site,
  pageIndex,
  sectionIndex,
  columnIndex,
  panelIndex,
  onSave,
  onFullSettings,
  onClose,
}) => {
  const layout = useSelector((state) => getLayout(state, site.id));
  const sources = useSelector(getSources);

  const tableType = useMemo(() => {
    try {
      return layout.pages[pageIndex].sections[sectionIndex].columns[columnIndex].panels[panelIndex]
        .tableType;
    } catch {
      return SWITCHGEAR_COUNTER_TABLE_TYPE;
    }
  }, [layout, pageIndex, sectionIndex, columnIndex, panelIndex]);

  const schema = useMemo(
    () => getAnalyticsTableOptionsSchema(tableType, sources, config.onPremise),
    [tableType, sources]
  );

  const formData = useMemo(() => {
    return normalizeAnalyticsTableSettings({
      tableType,
      settings: settings || {},
      sources,
      isOnPremise: config.onPremise,
    });
  }, [settings, tableType, sources]);

  return (
    <div className="column-content">
      <JsonEditor
        schema={schema}
        formData={formData}
        onFormSubmit={onSave}
        onSecondaryAction={onFullSettings}
        cancelCallback={onClose}
        saveButtonText={'Save'}
        initialEditMode
        showEditButton={false}
      />
    </div>
  );
};

export default AnalyticsTableSettings;
